import ExternalLink from '../../components/Links/ExternalLink'
import React from 'react'

const thuliumInternalLinkReqExp = /.*thulium\.(pl|com).*/

const cmsMarkdownRenderers = {
    link: (props) => {
        const isInternal = thuliumInternalLinkReqExp.test(props.href)
        if (isInternal) {
            return <a href={props.href}>{props.children}</a>
        } else {
            return <ExternalLink {...props}>{props.children}</ExternalLink>
        }
    },
}

export default cmsMarkdownRenderers
